import { apiEndpoint } from '../../config/app';
import createRestApiClient from '../utils/createRestApiClient';

export default () =>{
    const client = createRestApiClient().withConfig({ baseURL: apiEndpoint, withCredentials: true });
    return {
        getWebsites: () => client.request({
            method: 'GET',
            url: '/admin/website'
        }),
        deleteWebsite: (website) => client.request({
            method: 'DELETE',
            url: `/admin/website/${website.id}`
        }),
        updateWebsite: (website) => client.request({
            method: 'PUT',
            url: `/admin/website/${website.id}`,
            data : website
        }),
        getUsers:(params) => client.request({
            method: 'GET',
            url: '/admin/users',
            params: params
        }),
        deleteUser: (shopName) => client.request({
            method: 'DELETE',
            url: `/admin/user/${shopName}`
        }),
        updateSubscription:(id, subscription) => client.request({
            method: 'POST',
            url: `/admin/user/${id}/subscription`,
            data: {
                subscription: subscription
            }
        }),
        getGlobalSettings: () => client.request({
            method: 'GET',
            url: '/admin/settings'
        }),
        updateGlobalSettings: (expiringEnabled) => client.request({
            method: 'POST',
            url: '/admin/settings',
            data: {
                expiringEnabled: expiringEnabled
            }
        }),
        updateTokenMode: (id, tokenMode) => client.request({
            method: 'POST',
            url: `/admin/user/${id}/token-mode`,
            data: {
                tokenMode: tokenMode
            }
        })
    };
};


// WEBPACK FOOTER //
// app/services/admin.js